<script setup lang="ts">
import { Ref, ref, toRef } from 'vue'
import { catalogApi } from '@/api/client'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Upload, Loader2 } from 'lucide-vue-next'

const props = defineProps<{
    processing: boolean
}>()

const processing = toRef(props, 'processing')
const file: Ref<File | null> = ref(null)
const emit = defineEmits(['processing', 'error', 'success'])

const onFileChange = (event: Event) => {
    const target = event.target as HTMLInputElement
    file.value = target.files?.[0] ?? null
}

const upload = async () => {
    emit('processing')

    const formData = new FormData()
    formData.set('catalog', file.value as Blob)

    try {
        const uploadResponse = await catalogApi.upload(formData)
        emit('success')
        console.log(uploadResponse.data)
    } catch {
        emit('error')
        console.log('Could not upload the catalog')
    }
}
</script>

<template>
    <div class="flex flex-col gap-4">
        <Input
            type="file"
            accept="text/csv,text/xml"
            @change="onFileChange"
        />

        <Button
            variant="secondary"
            class="w-full"
            :disabled="file === null || processing"
            @click.prevent="upload"
        >
            Upload
            <Upload v-if="!processing" class="size-4" />
            <Loader2 v-else class="size-4 animate-spin" />
        </Button>
    </div>
</template>
